module.exports = __webpack_public_path__ + "media/field-of-application-hero.b9a86602.mp4";